import type { ListWithdrawal } from '../types';

export function getWithdrawalRequestStatusText(status: ListWithdrawal['status']): string | null {
	switch (status) {
		case 'PENDING':
			return 'Redo för utbetalning';
		case 'IN_REVIEW':
			return 'Under granskning';
		case 'REVIEW_DENIED':
			return 'Nekad utbetalning';
		default:
			return null;
	}
}
